import { Box, Typography } from '@mui/material';
import { formatDate } from '../utils/profileUtils';
import { ProfileTagsProps } from './ProfileTags.types';

/**
 * Profile tags component displaying station metadata information
 * Shows update date and user information in a tag-like format
 *
 * Features:
 * - Last update date display with formatted date
 * - User information (updated by or created by)
 * - Handles both object and string user data formats
 * - Fallback display for missing user information
 *
 * @param props - Component props containing station metadata
 * @returns JSX element containing formatted metadata tags
 */
export function ProfileTags({ stationData }: ProfileTagsProps): JSX.Element {
  if (!stationData) {
    return <></>;
  }
  return (
    <Box className="tags-section">
      <Box className="info-tag">
        <Typography className="tag-label">Дата оновлення:</Typography>
        <Typography className="tag-value">{formatDate(stationData.updated_at)}</Typography>
      </Box>

      {(stationData.updated_by || stationData.created_by) && (
        <Box className="info-tag">
          <Typography className="tag-label">{stationData.updated_by ? 'Оновлено:' : 'Створено:'}</Typography>
          <Typography className="tag-value">
            {typeof (stationData.updated_by || stationData.created_by) === 'object'
              ? ((stationData.updated_by || stationData.created_by) as any)?.display_name ||
                ((stationData.updated_by || stationData.created_by) as any)?.email ||
                'Невідомо'
              : String(stationData.updated_by || stationData.created_by)}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
